import {
    SET_DB_ACCOR
} from '../../actions';

const initialState = {
    boolean: true
}

function databaseAccordReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_DB_ACCOR:
            newState.boolean = action.status;
            return newState;
        
        default:
            return state;

    }
}

export default databaseAccordReducer;
